import React from 'react';
import { connect } from 'react-redux';
import { resetResults, setSearchQuery } from './actions.mjs';
import { debounce } from 'lodash';

class SearchField extends React.Component {
  constructor(props) {
    super(props);
    this.setSearchQueryDebounced = debounce(
      () => this.props.dispatch(setSearchQuery(this.state.query)),
      500
    );
    this.state = {
      query: '',
    };
    this.textInput = React.createRef();
  }

  componentDidMount() {
    this.textInput.focus();
    if (this.props.query) {
      this.setState({ query: this.props.query });
    }
  }

  handleChange(event) {
    this.setState({ query: event.target.value });
    this.setSearchQueryDebounced();
    }

    resetSearchQuery() {
        this.setState({ query: '' });
        this.props.dispatch(setSearchQuery(''));
        this.props.dispatch(resetResults());
    }

  render() {
    return (
      <div className="row">
        <div className="col text-center">
          <div className="search-page__input-wrapper">
            <input aria-label={this.props.translations.searchBarPlaceholder} ref={ (input) => { this.textInput = input; }}
              onChange={event => this.handleChange(event)}
              value={this.state.query}
              className="search-page__input"
              type="text"
              required
            />
            <span className="float-label">{this.props.translations.searchBarPlaceholder}</span>
            
                    {!this.state.query.length ? (
                        <div className="search-page__input-icon">
                            <i className="la icon-la-search" />
                        </div>
                    ) : (
                            <button
                                aria-label="Clear"
                                className="contact-search__input-icon"
                                onClick={() => this.resetSearchQuery()}
                            >
                                <i className="fa fa-times" />
                            </button>
                        )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    query: state.query,
    translations: state.translations,
  };
}

export default connect(mapStateToProps)(SearchField);
